import ForwardTracker from "../../../../../../prop-trackers/forward-tracker.js";
import SinglePropTracker from "../../../../../../prop-trackers/single-prop-tracker.js";
import PropTracker from "../../../../../../prop-trackers/prop-tracker.js";
import ValueTracker from "../../../../../../prop-trackers/value-tracker.js";
import { Mapper, ValueMapper } from "../../../../../../prop-tracker-utils/mapper.js";

class NameMapper extends ForwardTracker {
    constructor(objectTracker, evtCtx) {
        const mapper = new Mapper(objectTracker, (key) => new ObjectTracker(evtCtx));
        super(mapper);
    }
}

class ObjectTracker extends ValueMapper {
    constructor(evtCtx) {
        super();

        this._evtCtx = evtCtx;

        this._nameTracker = new SinglePropTracker();
        this._originalNameTracker = new SinglePropTracker();

        this._outputTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._nameTracker.listenNeedsUpdate(needsUpdate);
        this._originalNameTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(data) {
        const events = data ? this._evtCtx.getEvents(data) : null;

        this._nameTracker.track(data, events, "name");
        this._originalNameTracker.track(data, events, "originalName");
    }

    deleteValue() {
        this._nameTracker.track();
        this._originalNameTracker.track();
    }

    protected_startUpdate() {
        this._nameTracker.update(({ prop: { newValue: name } }) => {
            this._originalNameTracker.update(({ prop: { newValue: originalName } }) => {
                if (typeof originalName === "string") {
                    this._outputTracker.setValue(originalName);
                } else if (typeof name === "string") {
                    this._outputTracker.setValue(name);
                } else {
                    this._outputTracker.deleteValue();
                }
            });
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._outputTracker.finishUpdate();
    }
}

export default NameMapper;
